import { TitleDetail } from '@/interfaces/title-details-graphql';
import adminConfig from '@/features/promotions/config.json';

const CRUNCHY_SUBGENRES = [
	'jpan',
	'ghbl',
	'faan',
	'acma',
	'avgm',
	'acsm',
	'adva',
	'faef',
	'fadf',
	'famf',
	'scsw',
	'sccy',
	'scif',
	'dyad',
	'drrd',
	'drpd',
	'sprd',
	'coro',
	'coac',
	'sitc',
	'psch',
	'hosl',
	'hopa',
	'myst',
	'acat',
	'sciz',
	'syad',
	'entw',
	'detc',
	'cssa',
	'drmy',
];

const CRUNCHY_TAGS = [
	// Core Anime
	'anime',
	'animation',
	'japan',
	'japanese',
	'tokyo',
	'manga',
	'based_on_comics',

	// Space & Sci-Fi
	'dystopia',
	'cyberspace',
	'virtual_reality',

	// Fantasy Elements
	'dragon',
	'magic',
	'fairy',
	'fantasy_world',
	'medieval',
	'mythology',
	'legend',

	// Martial Arts
	'martial_arts',
	'sword_fight',
	'swords_and_armor',
	'samurai',
	'warrior',
	'fighting',
	'duel',
	'tournament',
	'championship',
	'contests_and_competitions',
	'battle_zone',
	'training',
];

const CRUNCHY_GENRES = ['ani', 'fnt', 'scf'];

type YieldOptimzationPromotion = { provider: string; placement: 'ft' };

export function getCrunchyrollTargeting(
	title: TitleDetail,
	country: string,
	provider: string
): YieldOptimzationPromotion | null {
	const activeCountries = adminConfig?.steering_overrides_global?.crunchyroll_tag_targeting_ft ?? ([] as string[]);
	if (!activeCountries.includes(country)) return null;

	// Never overwrite ATV FT with offer with CR FT
	if (provider === 'atp' && hasOffer('atp', title)) return null;
	// If has CR offer, return CR FT
	// If inPromotionCatalogue, return promotion from config
	if (hasOffer('cru', title)) return getPromotionFromShortName('cru');
	if (hasOffer(provider, title)) return null;

	const hasCrunchyrollTargeting =
		title.content.genres.some(g => CRUNCHY_GENRES.includes(g.shortName)) ||
		(title.content.tags ?? []).some(t => CRUNCHY_TAGS.includes(t.technicalName)) ||
		(title.content.subgenres ?? []).some(s => CRUNCHY_SUBGENRES.includes(s.content.shortName || ''));

	return hasCrunchyrollTargeting ? getPromotionFromShortName('cru') : null;
}

function getPromotionFromShortName(provider: string): YieldOptimzationPromotion {
	return { provider, placement: 'ft' };
}

function hasOffer(shortName: string, title: TitleDetail) {
	return title.offers.some(o => o.package.shortName === shortName);
}
